// extracted by mini-css-extract-plugin
export default {"card":"dZ-z","carouselContainer":"eZ-z","carouselContent":"fZ-z"};